// postgresql versions
export const DEFAULT_DB_VERSION = 17
export const DB_VERSIONS = [DEFAULT_DB_VERSION, 16, 15, 14, 13, 12, 11, 10]
// os types
export const OS_LINUX = 'linux'
export const OS_WINDOWS = 'windows'
export const OS_MAC = 'mac'
// db types
export const DB_TYPE_WEB = 'web'
export const DB_TYPE_OLTP = 'oltp'
export const DB_TYPE_DW = 'dw'
export const DB_TYPE_DESKTOP = 'desktop'
export const DB_TYPE_MIXED = 'mixed'
// size units
export const SIZE_UNIT_MB = 'MB'
export const SIZE_UNIT_GB = 'GB'
// harddrive types
export const HARD_DRIVE_SSD = 'ssd'
export const HARD_DRIVE_SAN = 'san'
export const HARD_DRIVE_HDD = 'hdd'
// maximum value for integer fields
export const MAX_NUMERIC_VALUE = 999999
